// Geometry of the paper vital-signs sheet. Display only: values come unchanged from the server series.
// As on paper, one unlabelled band sits below the 500 / 5 / 60 / 5 / 37 line.
// Colours are defaults; the configured ones come with the sheet (couleurs).
export const ECHELLES = [
    { key: 'diurese', label: 'Diurèse', unite: 'mL', couleur: '#a16207', min: 0, max: 2500, largeur: 84 },
    { key: 'ta', label: 'T.A', unite: 'cmHg', couleur: '#1f2937', min: 0, max: 25 },
    { key: 'pouls', label: 'Pouls', unite: 'bpm', couleur: '#dc2626', min: 40, max: 140 },
    { key: 'fr', label: 'F.R', unite: 'c/min', couleur: '#16a34a', min: 0, max: 25 },
    { key: 'temperature', label: 'T°', unite: '°C', couleur: '#2563eb', min: 36, max: 41 }
]
export const COULEUR_REPERE_37 = '#ef4444'
export const INTERVALLES = 5
export const SOUS_LIGNES = 5
export const HEURES_REPERES = [0, 6, 12, 18]
export const JOURS_MIN = 11
export const JOUR_MS = 86400000
export const COUPURE_MS = 24 * 3600000

export const echelle = key => ECHELLES.find(item => item.key === key)

export function graduations(e) {
    return Array.from({ length: INTERVALLES + 1 }, (_, i) => e.max - i * (e.max - e.min) / INTERVALLES)
}

// Out-of-scale values are clamped to the grid edge and flagged, never hidden.
export function versY(valeur, e, hauteur) {
    const ratio = (valeur - e.min) / (e.max - e.min)
    const hors = ratio > 1 ? 'haut' : ratio < 0 ? 'bas' : null
    return { y: hauteur * (1 - Math.min(1, Math.max(0, ratio))), hors }
}

const minuit = date => { const d = new Date(date); d.setHours(0, 0, 0, 0); return d }
const temps = point => new Date(point.date).getTime()

// J1 = admission day, otherwise the day of the first measure.
export function jourUn(debut, points) {
    const source = debut || (points.length ? points[0].date : null)
    return source && !Number.isNaN(new Date(source).getTime()) ? minuit(source) : null
}

// Calendar day index from J1; noon anchoring keeps the count stable across DST changes.
export function numeroJour(date, j1) {
    const midi = d => { const m = minuit(d); m.setHours(12); return m.getTime() }
    return Math.round((midi(date) - midi(j1)) / JOUR_MS) + 1
}

export function nombreJours(j1, points) {
    if (!j1) return JOURS_MIN
    return points.reduce((max, point) => Math.max(max, numeroJour(point.date, j1)), JOURS_MIN)
}

export function versX(date, j1, largeurJour) {
    const d = new Date(date)
    const heures = d.getHours() + d.getMinutes() / 60 + d.getSeconds() / 3600
    return (numeroJour(d, j1) - 1 + heures / 24) * largeurJour
}

// Consecutive measures of one constant are joined; a gap over 24 h starts a new line.
export function segments(points, key, coupure = COUPURE_MS) {
    const result = []
    let courant = [], precedent = null
    points.filter(point => typeof point[key] === 'number' && Number.isFinite(point[key])).forEach(point => {
        if (precedent !== null && temps(point) - precedent > coupure) { result.push(courant); courant = [] }
        courant.push(point); precedent = temps(point)
    })
    if (courant.length) result.push(courant)
    return result
}

export function taEnCmHg(ta) {
    return ta ? { sys: ta.sys_mmhg / 10, dia: ta.dia_mmhg / 10 } : null
}

// Paper convention: "12" over "07".
export function libelleCmHg(valeur) {
    const arrondi = Math.round(valeur * 10) / 10
    return Number.isInteger(arrondi) ? String(arrondi).padStart(2, '0') : String(arrondi).replace('.', ',')
}
